import { Modal, Button, Row, Col } from "antd";
import React, { MouseEvent, useContext } from 'react';
import { Download } from "react-feather";
import moment from "moment";
import { AppContext } from "../../context/AppContext";

interface Props {
    open: boolean;
    onClose: (e: MouseEvent<HTMLElement>) => void;
    receipt: any;
}

export const TransactionHistory: React.FC<Props> = ({ open, onClose, receipt }) => {
    const context = useContext(AppContext);
    const { onGetReceiptReports } = context;

    const myArray = new Uint32Array(1);
    const generateKey = crypto.getRandomValues(myArray);
    const keyId = Number(generateKey);

    const handleCsvDownload = async () => {
        const filename = `smdc-expresspay-${moment(new Date()).format("MMDDYYYY-hh-mm")}`;

        try {
            const reports = await onGetReceiptReports(receipt.payment_id)
            const blob = new Blob([reports], { type: 'text/csv' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;


            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (e) {
            console.error(e);
        } finally {
            return;
        }
    };

    const scheduledPayment = receipt?.recurring_payment_id ? "Yes" : "No"
    const propertyName = !receipt.name ? "N/A" : receipt.name
    const unit = !receipt.unit ? "N/A" : receipt.unit
    const buyerName = !receipt.buyers_name ? "N/A" : receipt.buyers_name
    const startDate = !receipt.start_date ? "N/A" : moment(receipt.start_date).format('YYYY-MM-DD')
    const duration = !receipt.duration ? "N/A" : receipt.duration
    const mdrFee = !receipt?.fee_details?.mdr ? 0 : receipt?.fee_details?.mdr
    const platformFee = !receipt?.fee_details?.platform ? 0 : receipt?.fee_details?.platform
    const transFee = !receipt.fees_amount? 0 : receipt.fees_amount
    const totalAmount = !receipt.total_amount ? 0 : receipt.total_amount
    const mayaNumber = receipt.channel === 'BayaniPay' ? "N/A" : receipt.payment_id

    return (
        <Modal
            key={receipt.reference_id}
            className="transactionModal custom-modal"
            title={<div className="custom-modal-title text-neutralBlack-90 text-header4 leading-7 font-interBold">{receipt.reference_id}</div>}
            open={open}
            onCancel={onClose}
            footer={[
                <div className="flex flex-row-reverse ml-auto" key={keyId}>
                    <hr className="mb-2"/>
                    <Button 
                        className="mr-4 ml-4 bg-primary font-interBold text-xs leading-6 border-primary hover:bg-primary-hovered hover:text-neutral-50 active:border-primary-border active:bg-primary-clicked" 
                        style={{ alignItems: 'center', width: "100%", display: 'flex', height: 40, color: '#FCFDFD', fontWeight: 700, fontSize: 12, borderRadius: 5, padding: '8px, 14px, 8px, 10px', justifyContent: 'center' }} 
                        key={keyId}
                        onClick={handleCsvDownload}
                    >
                            <Download style={{ width: 20, height: 20, color: "#FCFDFD", border: '1.5px' }} className="mr-2" />
                            Download CSV
                    </Button>
                </div>
            ]}
        >
            <div key={keyId} className="px-8 py-4">
                <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Date & Time
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {moment(receipt.created_at).format('YYYY-MM-DD HH:mm:ss')}
                    </Col>
                </Row>
                <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Transaction ID
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {receipt.reference_id}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Maya Number
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {mayaNumber}
                    </Col>
                 </Row>
                 {receipt.recurring_payment_id && (
                    <Row className="py-4 transaction-information">
                        <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                            Scheduled Payment
                        </Col>
                        <Col span={12} className="font-interRegular">
                            {scheduledPayment}
                        </Col>
                    </Row>
                 )}
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        CIN/HN
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {receipt.cin}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Entity
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {receipt.tenant}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Property Name
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {propertyName}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Unit Number
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {unit}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Buyer's Name
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {buyerName}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Payment Type
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {receipt.payment_type}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Payment Method
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {receipt.channel?.replace("_", " ")}
                    </Col>
                 </Row>
                 {receipt.recurring_payment_id && (
                    <Row className="py-4 transaction-information">
                        <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                            Start Date
                        </Col>
                        <Col span={12} className="font-interRegular">
                            {startDate}
                        </Col>
                    </Row>
                 )}
                 {receipt.recurring_payment_id && (
                    <Row className="py-4 transaction-information">
                        <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                            Duration
                        </Col>
                        <Col span={12} className="font-interRegular">
                            {duration}
                        </Col>
                    </Row>
                 )}
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        MDR
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {new Intl.NumberFormat('en-PH', {
                            style: 'currency',
                            currency: 'PHP',
                        }).format(parseFloat(mdrFee) / 100)}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Platform Fee
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {new Intl.NumberFormat('en-PH', {
                            style: 'currency',
                            currency: 'PHP',
                        }).format(parseFloat(platformFee) / 100)}
                    </Col>
                 </Row>
                 <Row className="py-4 transaction-information">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Transaction Fee
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {new Intl.NumberFormat('en-PH', {
                            style: 'currency',
                            currency: 'PHP',
                        }).format(parseFloat(transFee) / 100)}
                    </Col>
                 </Row>
                 <Row className="py-4">
                    <Col span={12} style={{ fontWeight: "bold" }} className="font-interBold">
                        Amount
                    </Col>
                    <Col span={12} className="font-interRegular">
                        {new Intl.NumberFormat('en-PH', {
                            style: 'currency',
                            currency: 'PHP',
                        }).format(parseFloat(totalAmount) / 100)}
                    </Col>
                 </Row>
            </div>
        </Modal>
    );
};